export const HOME_PAGE = {
  CTA_BUTTON: 'Prueba la nueva Home',
  SUMMARY: {
    TASKS_REMAINING: 'Tareas pendientes',
    COMPLETED_CONTROLS: 'Controles completados',
    TOTAL_COMPLIANCE: 'Cumplimiento Total',
  },
  TASKS: {
    TITLE: 'Tareas',
    TOTAL: 'Total',
    COMPLETION: 'PROGRESO',
    VIEW_ALL: (count: number) => `Ver todas las ${count} tareas`,
  },
  DOCUMENTATION: {
    TITLE: 'Documentación',
  },
  STANDARDS: {
    SHOW_LESS: 'Mostrar menos',
    VIEW_ALL: 'Ver todos los estándares',
    REQUEST: 'Solicitar',
  },
}

export const NEW_HOME = {
  TITLE: 'Inicio',
  SUBTITLE: 'Preparación de auditorías y postura de seguridad',
  TABS: {
    OVERVIEW: 'Resumen',
    COMPLIANCE: 'Cumplimiento',
    SECURITY: 'Seguridad',
  },
  MANAGER: {
    TITLE: 'Responsable de seguridad',
    TEAM: 'Equipo Qalea',
    ROLE: 'Tu responsable de seguridad',
    NOTES: 'Notas compartidas',
    SLACK: 'Abrir Slack',
    CONTACT: 'Contactar',
  },
  EXECUTIVE_REPORT: {
    BUTTON: 'Informe ejecutivo',
    TITLE: 'Informe ejecutivo',
    STEPS: [
      'Envíe la solicitud del informe ejecutivo',
      'El informe se genera con sus datos más recientes de cumplimiento y seguridad',
      'Una vez finalizado, se le envía automáticamente por correo electrónico',
    ],
    CANCEL: 'Cancelar',
    REQUEST: 'Enviar solicitud',
    SUBMITTING: 'Enviando solicitud',
    SENT_TITLE: 'Solicitud enviada',
    SENT_DESCRIPTION:
      'Su informe ejecutivo se está generando. Se le enviará por correo electrónico una vez esté finalizado.',
    DONE: 'Cerrar',
  },
  NOTIFICATIONS: {
    TITLE: 'Notificaciones',
    MARK_ALL_READ: 'Marcar todas como leídas',
    FILTERS: { all: 'Todas', task: 'Tareas', finding: 'Hallazgos', update: 'Novedades' },
    GROUPS: {
      task: 'Gestor de tareas',
      finding: 'Nuevos hallazgos',
      update: 'Novedades',
    },
    OPEN_TASKS: 'Abrir gestor de tareas',
    EMPTY: 'Aún no hay notificaciones',
    TYPES: {
      task_assigned: {
        MODULE: 'Gestor de tareas',
        TITLE: (params: Record<string, string>) => params.taskName,
        BODY: 'Le han asignado esta tarea.',
        CTA: 'Abrir tarea',
      },
      tasks_assigned: {
        MODULE: 'Gestor de tareas',
        TITLE: (params: Record<string, string>) => `${params.count} tareas`,
        BODY: 'Le han asignado estas tareas.',
        CTA: 'Abrir tareas',
      },
      task_due_soon: {
        MODULE: 'Gestor de tareas',
        TITLE: (params: Record<string, string>) => params.taskName,
        BODY: 'Vence en 2 días.',
        CTA: 'Abrir tarea',
      },
      tasks_due_soon: {
        MODULE: 'Gestor de tareas',
        TITLE: (params: Record<string, string>) => `${params.count} tareas`,
        BODY: 'Vencen en 2 días.',
        CTA: 'Abrir tareas',
      },
      task_overdue: {
        MODULE: 'Gestor de tareas',
        TITLE: (params: Record<string, string>) => params.taskName,
        BODY: 'Lleva 3 días vencida.',
        CTA: 'Abrir tarea',
      },
      tasks_overdue: {
        MODULE: 'Gestor de tareas',
        TITLE: (params: Record<string, string>) => `${params.count} tareas`,
        BODY: 'Llevan 3 días vencidas.',
        CTA: 'Abrir tareas',
      },
      control_assigned: {
        MODULE: 'Controles',
        TITLE: (params: Record<string, string>) => params.controlName,
        BODY: 'Le han asignado este control.',
        CTA: 'Abrir control',
      },
    },
  },
  STANDARDS: 'Estándares',
  KPIS: {
    READINESS: 'Preparación de auditoría',
    CONTROLS: 'Controles implementados',
    EVIDENCE: 'Evidencias aceptadas',
    DOCUMENTATION: 'Documentos aprobados',
    BLOCKERS: 'Bloqueos de auditoría',
    COMPLETED_TASKS: 'Tareas completadas',
  },
  TIMELINE: {
    TITLE: 'Calendario de certificación',
    TODAY: 'Hoy',
    PROGRESS: 'Progreso',
    INTERNAL: 'Auditoría interna',
    EXTERNAL: 'Auditoría externa',
    CONTROLS: 'controles',
    DETAILS: 'Mostrar detalles del estándar',
    BLOCKERS: (count: number) => `${count} bloqueos`,
    MORE: (count: number) => `+${count} más`,
  },
  TASKS: {
    TITLE: 'Tareas pendientes',
    VIEW_ALL: 'Ver todas las tareas',
    TODAY: 'Hoy',
    TOMORROW: 'Mañana',
    OVERDUE: 'Vencida',
    UNASSIGNED: 'Sin asignar',
    EMPTY: 'Sin tareas pendientes',
  },
  SECURITY: {
    TITLE: 'Postura de seguridad',
    CRITICAL: (count: number) => `${count} críticos`,
    CRITICAL_24H: (count: number) => `${count} críticos (24h)`,
    ALL_FIXED: 'Todo corregido',
    LAST_SCAN: 'Último escaneo',
    SCAN: (date: string) => `Escaneo: ${date}`,
    RESOLVED: (percent: number, fixed: number, total: number) => `${percent}% resuelto · ${fixed} de ${total}`,
    CHART_CAPTIONS: {
      RESPONSES: 'Respuestas por día',
      ALERTS: 'Alertas por día',
    },
    ALL_ALERTS: 'Todas las alertas',
    CHART: { TOTAL: 'Total', RESPONSES: 'respuestas automáticas', FIXED: 'corregidos', OPEN: 'abiertos' },
    ROWS: { MONITORING: 'Monitorización', POSTURE: 'Exposición' },
    SEE_DETAILS: 'Ver módulo',
    GO_TO: (module: string) => `Ir a ${module}`,
    CARDS: {
      EDR: 'EDR',
      SIEM: 'SIEM',
      APPSEC: 'AppSec',
      EASM: 'EASM',
      CLOUD: 'Cloud',
      VULNERABILITIES: 'Vulnerabilidades',
    },
    POSITIVE: {
      EDR: 'Endpoints protegidos',
      SIEM: 'Logs recopilados · 24h',
    },
    UNITS: {
      APPSEC: 'hallazgos abiertos',
      EASM: 'hallazgos externos abiertos',
      CLOUD: 'errores de configuración abiertos',
      VULNERABILITIES: 'CVEs abiertas',
    },
    CAPTIONS: {
      EDR: 'Amenazas bloqueadas automáticamente · 30 días',
      SIEM: 'Alertas · 30 días',
      APPSEC: 'Hallazgos abiertos',
      EASM: 'Hallazgos externos',
      CLOUD: 'Errores de configuración',
      VULNERABILITIES: 'CVEs abiertas',
    },
  },
}
